import { useState, useEffect } from "react";
import { Button } from "antd";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import { ChannelContainer } from "features/messages/src/components/ChannelContainer/ChannelContainer";
import { Sidebar } from "features/messages/src/components/Sidebar/Sidebar";
import { WorkspaceController } from "features/messages/src/context/WorkspaceController";
import { useChatContext } from "stream-chat-react";
import styled from "styled-components";

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100vh - 63px);
  overflow: hidden;
  position: relative;
`;

const ChannelContainerWrapper = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

const MobileSidebarToggle = styled(Button)`
  display: none;

  @media only screen and (max-width: 600px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 12px;
    ${(props) => (props.$isOpen ? "right: 12px; left: auto;" : "left: 12px; right: auto;")}
    z-index: 60;
  }
`;

export default function Messages() {
  const { client, channel } = useChatContext();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  useEffect(() => {
    if (channel?.cid) {
      setIsMobileSidebarOpen(false);
    }
  }, [channel?.cid]);

  if (!client) {
    return <div>Loading...</div>;
  }
  return (
    <WorkspaceController>
      <StyledDiv>
        <Sidebar isMobileOpen={isMobileSidebarOpen} />
        <MobileSidebarToggle
          type="primary"
          shape="circle"
          $isOpen={isMobileSidebarOpen}
          icon={isMobileSidebarOpen ? <CloseOutlined /> : <MenuOutlined />}
          onClick={() => setIsMobileSidebarOpen((v) => !v)}
          aria-label={isMobileSidebarOpen ? "Close sidebar" : "Open sidebar"}
        />
        <ChannelContainerWrapper>
          <ChannelContainer />
        </ChannelContainerWrapper>
      </StyledDiv>
    </WorkspaceController>
  );
}
